import {
    Component,
    ContainerSpecification,
    createSprite,
    SpriteSpecification,
    ValueText,
    ValueTextSpecification,
} from '@1x2network/pixi_assets'
import { ColorSource, Container, Sprite } from 'pixi.js'
import { formatPixiText } from '../../utils/formatCurrency'

/**
 * Single jackpot element displaying amount awarded from a jackpot
 * @author Jordan Harrison - <jordan.harrison@1x2network.com>
 * @version 1.0.0
 */

export class JackpotWidget extends Component<JackpotWidgetSpec> {
    private sprite: Sprite
    private text: ValueText
    private _value: number | null = null
    private _stake: number | null = null

    constructor(spec: JackpotWidgetSpec, parent: Container) {
        super({ spec, parent })
        this.sprite = createSprite({ spec: this.specification.sprite, parent: this })
        this.text = new ValueText({ spec: this.specification.text, parent: this, format: formatPixiText })
    }

    /**
     * Setter for the current stake
     * @param stake stake value
     */
    public set stake(stake: number) {
        this._stake = stake
        this.updateText()
    }

    /**
     * Setter for the prize value
     * @param value prize value
     */
    public set value(value: number) {
        this._value = value
        this.updateText()
    }

    /**
     * Update text to display off the base text
     */
    private updateText() {
        if (this._stake !== null && this._value !== null) {
            this.text.value = this._stake * this._value
        }
    }

    get tint() {
        return this.sprite.tint
    }

    set tint(value: ColorSource) {
        this.sprite.tint = value
        this.text.asset.tint = value
    }
}

export interface JackpotWidgetSpec extends ContainerSpecification {
    sprite: SpriteSpecification
    text: ValueTextSpecification
}
